import React, { useEffect, useState } from "react";
import { MediaListSwiper } from "./MediaListSwiper";
import { PostDetailsActionType } from "../Modals/PostDetailsModal/PostDetailsModalStore";
import { fetcherMediaList } from "../../DataFetchers/MediaFetcher";
import { MediaListType } from "@infrastructure/Services/MediaService";
import { ImagesModal } from "../Modals/ImagesModal/ImagesModal";
import { useInView } from "@infrastructure/Hooks/useInView";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import {
    ButtonContainer,
    ContainerStack,
    SectionTitle,
    ViewAllButton,
    ViewAllButtonText,
} from "./MediaSwiperContainer.styles";
import { useImagesModalStore } from "../Modals/ImagesModal/ImagesModalStore";
import { TippspielChevronRightIcon } from "@icons/TippspielChevronRightIcon";

export function MediaSwiperContainer({
    onPostCardClick,
}: {
    onPostCardClick: (postId: string, action?: PostDetailsActionType) => void;
}) {
    const { ref, inView } = useInView(true);

    const [previews, setPreviews] = useState<MediaListType[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (inView) {
            fetcherMediaList().then((mediaList) => {
                setPreviews(mediaList);
                setIsLoading(false);
            });
        }

        return () => {
            setPreviews([]);
            setIsLoading(true);
        };
    }, [inView]);

    const { getConfigs } = useGlobalConfigs();
    const { setIsImagesModalOpen } = useImagesModalStore();

    if (!getConfigs()?.tippspielFeedImageGalleryEnabled) {
        return null;
    }

    if (!isLoading && !previews.length) {
        return null;
    }

    return (
        <ContainerStack ref={ref}>
            <SectionTitle>Snapshots</SectionTitle>
            <MediaListSwiper
                previews={previews}
                onPostCardClick={onPostCardClick}
                isLoading={isLoading}
            />
            <ButtonContainer>
                <ViewAllButton
                    disableRipple
                    className={"fontFamily-inherited"}
                    onClick={() => setIsImagesModalOpen(true)}
                    variant={"text"}
                >
                    <ViewAllButtonText className={"fontFamily-inherited"}>
                        alle anzeigen
                    </ViewAllButtonText>
                    <TippspielChevronRightIcon />
                </ViewAllButton>
            </ButtonContainer>
            <ImagesModal onPostCardClick={onPostCardClick} />
        </ContainerStack>
    );
}
